import { DISCLAIMER_APPROVAL_SAVE_RESPONSE, DISCLAIMER_RESPONSE } from '../../../mocks/disclaimer.data';
import { IDisclaimerAdapterService } from './disclaimer-adapter.interface';
import { IDisclaimerApprovalSaveResponse, IDisclaimerResponse } from '../../../interfaces';
import { injectable } from 'inversify';

@injectable()
export class DisclaimerAdapterMock implements IDisclaimerAdapterService {
    getDisclaimerInfo(): Promise<IDisclaimerResponse> {
        return Promise.resolve(DISCLAIMER_RESPONSE);
    }

    sendApproval(): Promise<IDisclaimerApprovalSaveResponse> {
        return Promise.resolve(DISCLAIMER_APPROVAL_SAVE_RESPONSE);
    }
}
